import { ApiService } from '../../../services/api.service';
import { SellerDetailComponent } from '../seller-detail/seller-detail.component';
import { HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
var SellerManageComponent = (function () {
    function SellerManageComponent(apiService, modalService) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.username = localStorage.getItem('username');
        this.searchingName = false;
        this.searchingTaxID = false;
        this.loading = false;
        this.sellerDetails = [];
        this.sellerNames = [];
        this.sellerTaxIDs = [];
    }
    SellerManageComponent.prototype.ngOnInit = function () {
        this.loadData();
    };
    SellerManageComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        this.apiService.getSellerBranch()
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (res) {
            _this.sellerDetails = res;
            _this.setSellerNames();
            _this.setSellerTaxIDs();
        });
    };
    SellerManageComponent.prototype.setSellerNames = function () {
        this.sellerNames = this.sellerDetails.map(function (seller) { return seller.name_th; });
        // Make it unique
        this.sellerNames = this.sellerNames.filter(function (value, index, array) { return array.indexOf(value) === index; });
    };
    SellerManageComponent.prototype.setSellerTaxIDs = function () {
        this.sellerTaxIDs = this.sellerDetails.map(function (seller) { return seller.tax_id; });
        // Make it unique
        this.sellerTaxIDs = this.sellerTaxIDs.filter(function (value, index, array) { return array.indexOf(value) === index; });
    };
    SellerManageComponent.prototype.search = function () {
        var _this = this;
        var params = new HttpParams();
        if (this.searchName) {
            params = params.append('name', this.searchName);
        }
        if (this.searchTaxID) {
            params = params.append('tax_id', this.searchTaxID);
        }
        this.loading = true;
        this.apiService.getSellerBranch(params)
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (res) {
            _this.sellerDetails = res;
        });
    };
    SellerManageComponent.prototype.clearSearch = function () {
        this.searchName = null;
        this.searchTaxID = null;
        this.search();
    };
    SellerManageComponent.prototype.openModal = function (sellerDetail) {
        var _this = this;
        var modal = this.modalService.open(SellerDetailComponent, { backdrop: 'static', centered: true, windowClass: 'seller-detail-modal' });
        var modalContent = modal.componentInstance;
        modalContent.sellerDetail = sellerDetail;
        modal.result.then(function (result) {
            if (result) {
                _this.loadData();
            }
        });
    };
    return SellerManageComponent;
}());
export { SellerManageComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-manage/seller-manage.component.ts.pre-build-optimizer.js